<template>
  <div class="itinerary-section-item-opening-hour-season-item">
    <span class="item-days">{{ shortDays }}:</span>
    <ul class="item-hours">
      <li v-for="(h, hIdx) in item.hours" :key="`${item.days}_${hIdx}`">{{ h }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    shortDays() {
      return this.item.days
        .split(' - ')
        .map((d) => d.substring(0, 3))
        .join(' - ');
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.itinerary-section-item-opening-hour-season-item {
  width: 100%;
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  text-transform: uppercase;

  .item-days {
    width: 75px;

    @media (min-width: vars.$mobile-break-point + 1px) {
      width: 85px;
    }
  }

  .item-hours {
    list-style-type: none;
  }
}
</style>
